import React from 'react';
import './../../../Styles/Main/ProfilePage/ProfileOrderGeneral.scss';

function ProfileOrderGeneral({ ...props }) {
   return (
      <div className="generalOrderedInfo__body">
         <div className="generalOrderedInfo__cashSum">
            <div className="generalOrderedInfo__titleDelivery generalOrderedInfo__cashItem signature">Delivery:</div>
            <div className="generalOrderedInfo__titleSum generalOrderedInfo__cashItem signature">Total:</div>
            <div className="generalOrderedInfo__costDelivery generalOrderedInfo__cashItem text">0 USD</div>
            <div className="generalOrderedInfo__costSum generalOrderedInfo__cashItem text">{props.sum} USD</div>
         </div>
         <div className="generalOrderedInfo__rentInfo">
            <div className="generalOrderedInfo__item text">Type of rent:{ props.typeRent }</div>
            <div className="generalOrderedInfo__item text">Period: {props.startDate} - {props.finishDate }</div>
            <div className="generalOrderedInfo__item text">Payment: { props.payment }</div>
            <div className="generalOrderedInfo__item text">Delivery: { props.delivery }</div>
         </div>
      </div>
      
   );
}
export default ProfileOrderGeneral;